__turbopack_context__.v({
  "phoneError": "CustomPhoneInput-module__XY-x4q__phoneError",
  "phoneFormItem": "CustomPhoneInput-module__XY-x4q__phoneFormItem",
});
